// extracted by mini-css-extract-plugin
export var root = "carousel-layout-module--root--Q4MX6";
export var title = "carousel-layout-module--title--Jmw9g";
export var carousel = "carousel-layout-module--carousel--3-fj2";
export var imageBlock = "carousel-layout-module--imageBlock--zQ0jM";
export var youtubeBlock = "carousel-layout-module--youtubeBlock--4mmgy";
export var contributorBlock = "carousel-layout-module--contributorBlock--a5F+b";
export var collectionBlock = "carousel-layout-module--collectionBlock--jdvak";
export var contributor = "carousel-layout-module--contributor--dr-aE";